import { useState, useEffect, useRef, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const T = {
  bg: '#f0f5e8', cream: '#fffef0', greenDk: '#1b5e20', greenPale: '#e8f5e9',
  maroon: '#6d1b1b', orange: '#e65100', gold: '#f0d48a', border: '#c8e6c9',
  header: 'linear-gradient(135deg, #090b72, #1a237e)', saffron: '#fff8e1',
};

const SUGGESTIONS = [
  { q:'இன்றைய பஞ்சாங்கம்', sub:'திதி நக்ஷத்ரம் யோகம்', sub2:'காலம் உதயம் அஸ்தமனம்' },
  { q:'அடுத்த ஏகாதசி', sub:'விரதம் உபவாசம்', sub2:'சுக்ல கிருஷ்ண' },
  { q:'அடுத்த அமாவாசை', sub:'தர்ப்பணம் ச்ராத்தம்', sub2:'ஊனம் பித்ரு' },
  { q:'அடுத்த பூர்ணிமா', sub:'பௌர்ணமி வழிபாடு', sub2:'சுக்ல பக்ஷம்' },
  { q:'முகூர்த்தம்', sub:'விவாஹம் லக்னம்', sub2:'சுப நக்ஷத்ரம் திதி' },
  { q:'தீட்டு', sub:'மரணம் ஜனனம்', sub2:'நாட்கள் விதிகள்' },
  { q:'ராகு காலம்', sub:'எமகண்டம் குளிகை', sub2:'நாள் நேரம்' },
  { q:'நட்சத்திர பலன்', sub:'27 நக்ஷத்ரம்', sub2:'ராசி கிரஹம்' },
  { q:'சங்கல்பம்', sub:'தர்ப்பணம் பூஜை', sub2:'திதி நக்ஷத்ரம்' },
  { q:'ஓரை', sub:'கிரஹ ஓரை', sub2:'சுபம் அசுபம்' },
  { q:'எண்கணிதம்', sub:'பெயர் எண்', sub2:'ஜன்ம எண் பாக்ய எண்' },
  { q:'விவசாயம்', sub:'நாற்று நடவு', sub2:'பருவம் விதை' },
  { q:'நாள் தோஷம்', sub:'நாள் பலன்', sub2:'சுபம் அசுபம்' },
  { q:'தினப் பொருத்தம்', sub:'தாரா பலன்', sub2:'சந்திராஷ்டமம்' },
];

const MORE_SUGGESTIONS = [
  { q:'சதுர்த்தி', sub:'விநாயகர்', sub2:'சங்கடஹர' },
  { q:'ஷஷ்டி', sub:'முருகன்', sub2:'ஸ்கந்த' },
  { q:'பிரதோஷம்', sub:'சிவன் வழிபாடு', sub2:'த்ரயோதசி' },
  { q:'சிவராத்திரி', sub:'மஹா சிவராத்திரி', sub2:'வ்ரதம்' },
  { q:'கிருத்திகை', sub:'முருகன்', sub2:'தீபம்' },
  { q:'சுப நாட்கள்', sub:'நல்ல நாள் முகூர்த்தம்', sub2:'கிரஹப்ரவேசம் உபநயனம்' },
  { q:'வாக்ய ஜாதகம்', sub:'ஜாதகம் கணித்தல்', sub2:'லக்னம் ராசி நவாம்சம்' },
  { q:'ஜாதகப் பொருத்தம்', sub:'12 பொருத்தம்', sub2:'நக்ஷத்ர பொருத்தம்' },
  { q:'கௌரி பஞ்சாங்கம்', sub:'பக்ஷி சாஸ்திரம்', sub2:'வெற்றி சக்ரம்' },
  { q:'மரண தீட்டு', sub:'இறப்பு மரணம்', sub2:'நாட்கள் உறவு' },
  { q:'ஜனன தீட்டு', sub:'பிறப்பு ஆசௌசம்', sub2:'பங்காளி பிரசவம்' },
  { q:'நட்சத்திர விபரங்கள்', sub:'27 நக்ஷத்ரம்', sub2:'பாதம் ராசி' },
  { q:'ஸ்ராத்த திதி', sub:'ஸ்ராத்தம் தர்ப்பணம்', sub2:'பித்ரு கர்மா' },
  { q:'ஊன நாட்கள்', sub:'மாசிக ச்ராத்தம்', sub2:'ஊனம் பட்டியல்' },
  { q:'நவக்கிரகங்கள்', sub:'சூரியன் சந்திரன்', sub2:'ராகு கேது' },
  { q:'நாழி மாற்றி', sub:'முகூர்த்த வாக்யம்', sub2:'கஸர யோகம்' },
  { q:'நடப்பு வருடம்', sub:'வருட பலன்', sub2:'60 வருட சக்கரம்' },
  { q:'லக்னம்', sub:'12 லக்னங்கள்', sub2:'ராசி பலன்' },
  { q:'தசா புக்தி', sub:'நட்சத்திர தசை', sub2:'கிரக அந்தரம்' },
  { q:'பஞ்சாங்கத்தின் பாகங்கள்', sub:'திதி வாரம் நட்சத்திரம்', sub2:'யோகம் கரணம்' },
  { q:'திதி நிர்ணயம்', sub:'புண்யகால விதிகள்', sub2:'ஸ்ராத்த நிர்ணயம்' },
  { q:'விவசாயம்', sub:'நாற்று நடவு', sub2:'பருவம் விதை' },
];

const NAV_MAP = {
  // Panchangam
  'பஞ்சாங்கம்': '/panchangam/panchangam', 'இன்றைய பஞ்சாங்கம்': '/panchangam/panchangam',
  'காலண்டர்': '/panchangam/calendar', 'மாத காட்டி': '/panchangam/monthly',
  'மாத பஞ்சாங்கம்': '/panchangam/monthly',
  // Astrology
  'நட்சத்திர பலன்': '/panchangam/dayvalue', 'நாள் மதிப்பு': '/panchangam/dayvalue',
  'தசா புக்தி': '/panchangam/dasabukthi', 'தசாபுக்தி': '/panchangam/dasabukthi',
  'ஜாதகம்': '/panchangam/casting', 'வாக்ய ஜாதகம்': '/panchangam/casting',
  'ஜாதகப் பொருத்தம்': '/panchangam/matching', 'திருமண பொருத்தம்': '/panchangam/matching',
  '10 பொருத்தம்': '/panchangam/matching', '12 பொருத்தம்': '/panchangam/matching',
  'தினப் பொருத்தம்': '/panchangam/dhinaporutham', 'தாரா பலன்': '/panchangam/dhinaporutham',
  'நாள் தோஷம்': '/panchangam/day-dhosha', 'தோஷம்': '/panchangam/day-dhosha',
  'நவக்கிரகம்': '/panchangam/navagrahas', 'நவக்கிரகங்கள்': '/panchangam/navagrahas',
  'லக்னம்': '/panchangam/lagnas', 'லக்னங்கள்': '/panchangam/lagnas', 'ராசி': '/panchangam/lagnas',
  'நட்சத்திர விபரங்கள்': '/panchangam/allaboutstars', '27 நட்சத்திரம்': '/panchangam/allaboutstars',
  'எண்கணிதம்': '/panchangam/numerology', 'எண் கணிதம்': '/panchangam/numerology',
  // Panchangam tools
  'ஓரை': '/panchangam/horai', 'ஹோரை': '/panchangam/horai',
  'கௌரி பஞ்சாங்கம்': '/panchangam/gowri-panchangam', 'பக்ஷி': '/panchangam/gowri-panchangam',
  'வெற்றி': '/panchangam/gowri-panchangam',
  'சங்கல்பம்': '/panchangam/gen-sankalpam', 'தர்ப்பண சங்கல்பம்': '/panchangam/sankalpam',
  'தர்ப்பணம்': '/panchangam/sankalpam',
  'ராகு காலம்': '/panchangam/diary', 'எமகண்டம்': '/panchangam/diary', 'டயரி': '/panchangam/diary',
  'பஞ்சாங்கத்தின் பாகங்கள்': '/panchangam/parts-of-panchangam',
  'திதி': '/panchangam/parts-of-panchangam', 'யோகம்': '/panchangam/parts-of-panchangam',
  'கரணம்': '/panchangam/parts-of-panchangam',
  // Muhurtham
  'முகூர்த்தம்': '/panchangam/my-muhurthams', 'சுப நாட்கள்': '/panchangam/good-days',
  'சுப முகூர்த்தம்': '/panchangam/good-days',
  'நிகழ்வுகளுக்கு சிறந்த நாள்': '/panchangam/best-for-events',
  'கிரஹப்ரவேசம்': '/panchangam/best-for-events', 'நாமகரணம்': '/panchangam/best-for-events',
  'உபநயனம்': '/panchangam/best-for-events',
  // Theetu
  'தீட்டு': '/panchangam/theetu', 'தீட்டு விதிகள்': '/panchangam/theetu',
  'மரண தீட்டு': '/panchangam/marana-theetu', 'இறப்பு தீட்டு': '/panchangam/marana-theetu',
  'ஜனன தீட்டு': '/panchangam/gentheetu', 'பிறப்புத் தீட்டு': '/panchangam/gentheetu',
  'ஆசௌசம்': '/panchangam/gentheetu', 'ஜனன ஆசௌசம்': '/panchangam/gentheetu',
  'பங்காளி': '/panchangam/gentheetu', 'பிரசவம்': '/panchangam/gentheetu',
  'சட்டி தொடுதல்': '/panchangam/gentheetu', 'குறைப் ப்ரசவம்': '/panchangam/gentheetu',
  // Vaideekam
  'ஸ்ராத்தம்': '/panchangam/shradhdha-thithi', 'ஸ்ராத்த திதி': '/panchangam/shradhdha-thithi',
  'ஊனம்': '/panchangam/oonams', 'ஊன நாட்கள்': '/panchangam/oonams',
  'முழு ஊன பட்டியல்': '/panchangam/full-oonam-list',
  'திதி நிர்ணயம்': '/panchangam/thithi-nirnaya-rules',
  'விவசாயம்': '/panchangam/vivasayam',
  // Utility
  'நாழி': '/panchangam/nazhi-convert', 'நாழி மாற்றி': '/panchangam/nazhi-convert',
  'நடப்பு வருடம்': '/panchangam/currentyear', 'வருட பலன்': '/panchangam/currentyear',
  // Other
  'திவ்ய தேசம்': '/divyadesams', 'திவ்யதேசம்': '/divyadesams',
  'தர்ம சாஸ்திரம்': '/dharma-sastram',
};

// Thanglish (Tamil in English letters) → Navigation routes
const THANGLISH_NAV = {
  // Panchangam
  'panchangam': '/panchangam/panchangam', 'panchang': '/panchangam/panchangam', 'panjangam': '/panchangam/panchangam',
  'today panchangam': '/panchangam/panchangam', 'live panchangam': '/panchangam/panchangam',
  'calendar': '/panchangam/calendar', 'kalandar': '/panchangam/calendar',
  'monthly': '/panchangam/monthly', 'month view': '/panchangam/monthly',
  // Astrology
  'nakshatra': '/panchangam/dayvalue', 'natchathira': '/panchangam/dayvalue', 'natchathiram': '/panchangam/dayvalue',
  'star': '/panchangam/dayvalue', 'day value': '/panchangam/dayvalue', 'star value': '/panchangam/dayvalue',
  'dasa bukthi': '/panchangam/dasabukthi', 'dasa': '/panchangam/dasabukthi', 'dasabukthi': '/panchangam/dasabukthi',
  'casting': '/panchangam/casting', 'jathagam': '/panchangam/casting', 'jathakam': '/panchangam/casting',
  'horoscope': '/panchangam/casting', 'vakya jathagam': '/panchangam/casting',
  'matching': '/panchangam/matching', 'porutham': '/panchangam/matching', 'marriage matching': '/panchangam/matching',
  'thirumanam': '/panchangam/matching', 'marriage': '/panchangam/matching',
  'dhinaporutham': '/panchangam/dhinaporutham', 'dhina porutham': '/panchangam/dhinaporutham',
  'day dhosha': '/panchangam/day-dhosha', 'dosham': '/panchangam/day-dhosha', 'dhosham': '/panchangam/day-dhosha',
  'navagraha': '/panchangam/navagrahas', 'navagraham': '/panchangam/navagrahas', 'planets': '/panchangam/navagrahas',
  'lagnam': '/panchangam/lagnas', 'lagna': '/panchangam/lagnas', 'rasi': '/panchangam/lagnas',
  'numerology': '/panchangam/numerology', 'enganitham': '/panchangam/numerology', 'name number': '/panchangam/numerology',
  'all about stars': '/panchangam/allaboutstars', '27 stars': '/panchangam/allaboutstars',
  // Panchangam Tools
  'horai': '/panchangam/horai', 'orai': '/panchangam/horai', 'hora': '/panchangam/horai',
  'gowri': '/panchangam/gowri-panchangam', 'gauri': '/panchangam/gowri-panchangam',
  'gowri panchangam': '/panchangam/gowri-panchangam', 'pakshi': '/panchangam/gowri-panchangam',
  'victory': '/panchangam/gowri-panchangam', 'vetri': '/panchangam/gowri-panchangam',
  'sankalpam': '/panchangam/gen-sankalpam', 'sankalpa': '/panchangam/gen-sankalpam',
  'tarpanam': '/panchangam/sankalpam', 'tarpanam sankalpam': '/panchangam/sankalpam',
  'rahu kalam': '/panchangam/diary', 'rahu': '/panchangam/diary', 'rahukalam': '/panchangam/diary',
  'raghu kalam': '/panchangam/diary', 'yamagandam': '/panchangam/diary', 'diary': '/panchangam/diary',
  'parts of panchangam': '/panchangam/parts-of-panchangam',
  // Muhurtham
  'muhurtham': '/panchangam/my-muhurthams', 'muhurtha': '/panchangam/my-muhurthams', 'muhurtam': '/panchangam/my-muhurthams',
  'good days': '/panchangam/good-days', 'subha days': '/panchangam/good-days', 'nalla naal': '/panchangam/good-days',
  'best for events': '/panchangam/best-for-events', 'gruhapravesam': '/panchangam/best-for-events',
  'upanayanam': '/panchangam/best-for-events', 'namakaranam': '/panchangam/best-for-events',
  // Theetu
  'theetu': '/panchangam/theetu', 'theettu': '/panchangam/theetu', 'theetu rules': '/panchangam/theetu',
  'pollution': '/panchangam/theetu', 'asaucham': '/panchangam/theetu',
  'marana theetu': '/panchangam/marana-theetu', 'death theetu': '/panchangam/marana-theetu',
  'death pollution': '/panchangam/marana-theetu', 'irappu theetu': '/panchangam/marana-theetu',
  'janana theetu': '/panchangam/gentheetu', 'birth theetu': '/panchangam/gentheetu',
  'pirappu theetu': '/panchangam/gentheetu', 'birth pollution': '/panchangam/gentheetu',
  'janana asoucham': '/panchangam/gentheetu', 'pangali': '/panchangam/gentheetu',
  'prasavam': '/panchangam/gentheetu', 'delivery theetu': '/panchangam/gentheetu',
  // Vaideekam
  'shraddha': '/panchangam/shradhdha-thithi', 'shradha': '/panchangam/shradhdha-thithi',
  'shrartham': '/panchangam/shradhdha-thithi', 'shradhdha thithi': '/panchangam/shradhdha-thithi',
  'oonam': '/panchangam/oonams', 'oonam list': '/panchangam/full-oonam-list',
  'thithi nirnaya': '/panchangam/thithi-nirnaya-rules',
  'vivasayam': '/panchangam/vivasayam', 'agriculture': '/panchangam/vivasayam', 'farming': '/panchangam/vivasayam',
  // Utility
  'nazhi': '/panchangam/nazhi-convert', 'nazhigai': '/panchangam/nazhi-convert', 'tools': '/panchangam/nazhi-convert',
  'current year': '/panchangam/currentyear', 'this year': '/panchangam/currentyear', 'year prediction': '/panchangam/currentyear',
  // Other
  'divyadesam': '/divyadesams', '108 divyadesam': '/divyadesams',
  'contact': '/contact', 'feedback': '/panchangam/feedback', 'about': '/panchangam/about',
  'home': '/', 'search': '/panchangam/search',
  'dharma sastram': '/dharma-sastram', 'shop': '/shop',
  'premium': '/panchangam/premiumstore',
};

// Thanglish → Tamil keyword translation for panchangam data search
const THANGLISH_TAMIL = {
  // Thithi names
  'prathamai': 'பிரதமை', 'pratipad': 'பிரதமை', 'dvitiyai': 'துவிதியை', 'dwitiya': 'துவிதியை',
  'tritiyai': 'திருதியை', 'tritiya': 'திருதியை', 'chaturthi': 'சதுர்த்தி', 'chathurthi': 'சதுர்த்தி',
  'panchami': 'பஞ்சமி', 'shashti': 'ஷஷ்டி', 'sashti': 'ஷஷ்டி', 'shasti': 'ஷஷ்டி',
  'saptami': 'சப்தமி', 'ashtami': 'அஷ்டமி', 'navami': 'நவமி',
  'dasami': 'தசமி', 'ekadasi': 'ஏகாதசி', 'ekadashi': 'ஏகாதசி',
  'dwadasi': 'துவாதசி', 'dwadashi': 'துவாதசி', 'trayodasi': 'த்ரயோதசி', 'pradosham': 'த்ரயோதசி',
  'chaturdasi': 'சதுர்தசி', 'pournami': 'பூர்ணிமா', 'poornam': 'பூர்ணிமா', 'fullmoon': 'பூர்ணிமா',
  'amavasai': 'அமாவாசை', 'amavasya': 'அமாவாசை', 'newmoon': 'அமாவாசை',
  // Nakshatra names
  'ashwini': 'அஸ்வினி', 'aswini': 'அஸ்வினி', 'bharani': 'பரணி',
  'krithigai': 'கிருத்திகை', 'krittikai': 'கிருத்திகை', 'karthigai': 'கிருத்திகை',
  'rohini': 'ரோகிணி', 'mrigasheersham': 'மிருகசீரிஷம்', 'mrigasira': 'மிருகசீரிஷம்',
  'thiruvathirai': 'திருவாதிரை', 'ardra': 'திருவாதிரை',
  'punarpusam': 'புனர்பூசம்', 'punarvasu': 'புனர்பூசம்',
  'pusam': 'பூசம்', 'pushya': 'பூசம்', 'poosam': 'பூசம்',
  'ayilyam': 'ஆயில்யம்', 'ashlesha': 'ஆயில்யம்',
  'magam': 'மகம்', 'makam': 'மகம்', 'magha': 'மகம்',
  'pooram': 'பூரம்', 'purva': 'பூரம்',
  'uthiram': 'உத்திரம்', 'uttara': 'உத்திரம்',
  'hastham': 'அஸ்தம்', 'hasta': 'அஸ்தம்',
  'chithirai': 'சித்திரை', 'chitra': 'சித்திரை',
  'swathi': 'சுவாதி', 'swati': 'சுவாதி',
  'visakam': 'விசாகம்', 'vishakam': 'விசாகம்', 'visaka': 'விசாகம்',
  'anusham': 'அனுஷம்', 'anuradha': 'அனுஷம்',
  'kettai': 'கேட்டை', 'jyeshta': 'கேட்டை',
  'moolam': 'மூலம்', 'moola': 'மூலம்',
  'pooradam': 'பூராடம்', 'purvashada': 'பூராடம்',
  'uthiradam': 'உத்திராடம்', 'uttarashada': 'உத்திராடம்',
  'thiruvonam': 'திருவோணம்', 'sravana': 'திருவோணம்', 'onam': 'திருவோணம்',
  'avittam': 'அவிட்டம்', 'dhanishta': 'அவிட்டம்',
  'sathayam': 'சதயம்', 'sathabisha': 'சதயம்',
  'poorattathi': 'பூரட்டாதி', 'purvabhadra': 'பூரட்டாதி',
  'uthirattathi': 'உத்திரட்டாதி', 'uttarabhadra': 'உத்திரட்டாதி',
  'revathi': 'ரேவதி', 'revati': 'ரேவதி',
  // Yoga names
  'vaidhriti': 'வைத்ரு', 'vaidhrithi': 'வைத்ரு', 'vyathipatha': 'வ்யதீ', 'vyatipata': 'வ்யதீ',
  // Paksham
  'shukla': 'சுக்ல', 'sukla': 'சுக்ல', 'krishna': 'கிருஷ்ண',
  // Common temporal queries
  'indru': 'இன்று', 'today': 'இன்று', 'naalai': 'நாளை', 'tomorrow': 'நாளை',
  'adutha': 'அடுத்த', 'next': 'அடுத்த', 'upcoming': 'அடுத்த',
  'pona': 'போன', 'last': 'போன', 'previous': 'போன', 'kadantha': 'கடந்த',
  // Common queries
  'naal eppadi': 'நாள் தோஷம்', 'nal eppadi': 'நாள் தோஷம்',
  'thiruvadi': 'திருவாதிரை', 'thiruvadirai': 'திருவாதிரை',
  'sivarathri': 'சிவராத்திரி', 'shivaratri': 'சிவராத்திரி',
  'vinayagar': 'சதுர்த்தி', 'ganesh': 'சதுர்த்தி', 'pillayar': 'சதுர்த்தி',
  'murugan': 'ஷஷ்டி', 'skanda': 'ஷஷ்டி',
};

const RECENT_KEY = 'pp_recent_results'; // stores {query, date, thithi, nakshatra, special, ts}
const FEEDBACK_KEY = 'pp_search_feedback';

const SearchPage = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [allData, setAllData] = useState([]);
  const [theetuData, setTheetuData] = useState({ birth: [], death: [] });
  const [results, setResults] = useState([]);
  const [theetuResults, setTheetuResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showSugg, setShowSugg] = useState(true);
  const [showMore, setShowMore] = useState(false);
  const [noResults, setNoResults] = useState(false);
  const [recentSearches, setRecent] = useState([]);
  const [tab, setTab] = useState('suggestions');
  const [voiceActive, setVoiceActive] = useState(false);
  const [voiceText, setVoiceText] = useState('');
  const [feedbackGiven, setFeedbackGiven] = useState({});
  const webRecRef = useRef(null);

  // Load data
  useEffect(() => {
    axios.get('/data/panchangam_data-2025-to-2028.json')
      .then(r => setAllData(r.data || []))
      .catch(() => {});
    // Load theetu data for relationship-based searches
    Promise.all([
      axios.get('/data/btheetu.json').catch(() => ({ data: [] })),
      axios.get('/data/dtheetu.json').catch(() => ({ data: [] })),
    ]).then(([b, d]) => setTheetuData({ birth: b.data || [], death: d.data || [] }));
    try { setRecent(JSON.parse(localStorage.getItem(RECENT_KEY) || '[]')); } catch { setRecent([]); }
  }, []);

  // Save successful result with top match data to சமீபத்தியவை
  const saveRecent = useCallback((q, topResult) => {
    const t = q.trim();
    if (!t || t.length < 2) return;
    const entry = {
      query: t,
      date: topResult?.EnglishDate || '',
      thithi: topResult?.ThithiNameInTamil || '',
      nakshatra: topResult?.NakshatraNameInTamil || '',
      special: topResult?.DaySpecialityInTamil || '',
      tamilDate: topResult?.TamilMonth ? `${topResult.TamilMonth}-${topResult.TamilDate}` : '',
      ts: Date.now(),
    };
    const updated = [entry, ...recentSearches.filter(r => r.query !== t)].slice(0, 15);
    setRecent(updated);
    localStorage.setItem(RECENT_KEY, JSON.stringify(updated));
  }, [recentSearches]);

  const saveFeedback = (queryStr, useful) => {
    const fb = JSON.parse(localStorage.getItem(FEEDBACK_KEY) || '{}');
    fb[queryStr] = { useful, ts: Date.now() };
    localStorage.setItem(FEEDBACK_KEY, JSON.stringify(fb));
    setFeedbackGiven(prev => ({ ...prev, [queryStr]: useful }));
  };

  // Extract date from query
  const extractDate = (q) => {
    const m = q.match(/(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})/);
    if (m) return { month: parseInt(m[2]), day: parseInt(m[1]), year: parseInt(m[3]) };
    return null;
  };

  // Search function
  const doSearch = useCallback((searchQuery) => {
    if (!searchQuery || !searchQuery.trim()) return;
    const q = searchQuery.trim().toLowerCase();
    setIsLoading(true);
    setShowSugg(false);
    setNoResults(false);
    setResults([]);
    setTheetuResults([]);

    // Check NAV_MAP first (Tamil)
    for (const [key, route] of Object.entries(NAV_MAP)) {
      if (q.includes(key.toLowerCase()) || key.toLowerCase().includes(q)) {
        navigate(route);
        setIsLoading(false);
        return;
      }
    }

    // Check Thanglish NAV_MAP (English transliteration)
    for (const [key, route] of Object.entries(THANGLISH_NAV)) {
      if (q.includes(key) || key.includes(q)) {
        saveRecent(searchQuery.trim());
        navigate(route);
        setIsLoading(false);
        return;
      }
    }

    // Special navigations (Tamil)
    if (q.includes('தீட்டு') && (q.includes('மரண') || q.includes('இறப்பு') || q.includes('மரணம்'))) { navigate('/panchangam/marana-theetu'); setIsLoading(false); return; }
    if (q.includes('தீட்டு') && (q.includes('ஜனன') || q.includes('பிறப்பு') || q.includes('பிரசவ') || q.includes('ஆசௌச'))) { navigate('/panchangam/gentheetu'); setIsLoading(false); return; }
    if (q.includes('ஆசௌசம்') || q.includes('ஆசௌச')) { navigate('/panchangam/gentheetu'); setIsLoading(false); return; }
    if (q.includes('தீட்டு')) { navigate('/panchangam/theetu'); setIsLoading(false); return; }

    // Translate Thanglish to Tamil for panchangam search
    let tamilQ = q;
    for (const [eng, tam] of Object.entries(THANGLISH_TAMIL)) {
      if (q.includes(eng)) { tamilQ = q.replace(new RegExp(eng, 'gi'), tam); break; }
    }

    // Date search
    const dateInfo = extractDate(searchQuery.trim());
    if (dateInfo) {
      const found = allData.filter(d => {
        const key = d.EnglishDate;
        if (!key) return false;
        const parts = key.split('/');
        return parseInt(parts[0]) === dateInfo.month && parseInt(parts[1]) === dateInfo.day && parseInt(parts[2]) === dateInfo.year;
      });
      if (found.length > 0) {
        setResults(found.map(d => ({ item: d, score: 100, matched: ['Exact Date'] })));
        setIsLoading(false);
        saveRecent(searchQuery.trim(), found[0]);
        return;
      }
    }

    // Keyword search — strip temporal prefixes for field matching
    const matched = [];
    const now = new Date(); now.setHours(0, 0, 0, 0);
    const useQ = tamilQ !== q ? tamilQ : q; // prefer translated Thanglish
    const cleanQ = useQ.replace(/அடுத்த|போன|கடந்த|முந்தைய|next|last|upcoming|adutha|pona|kadantha/gi, '').trim();
    const searchTerms = cleanQ ? [cleanQ] : [useQ];

    for (const d of allData) {
      let score = 0;
      const fields = [];
      const searchFields = [
        d.ThithiNameInTamil, d.NakshatraNameInTamil, d.YogaNameInTamil,
        d.KaranamNameInTamil, d.DaySpecialityInTamil, d.DayNameInTamil,
        d.YearNameInTamil, d.TamilMonth, d.PakshamNameInTamil,
        d.ShraadhdhaThithiNameInTamil, d.EnglishDate,
      ];

      for (const term of searchTerms) {
        for (const f of searchFields) {
          if (f && f.toLowerCase().includes(term)) {
            score += 50;
            fields.push(f);
          }
        }
      }

      if (score > 0) {
        const itemDate = new Date(d.EnglishDate);
        if (itemDate >= now) score += 20;
        matched.push({ item: d, score, matched: fields });
      }
    }

    // Temporal smart sort
    if (q.includes('அடுத்த') || q.includes('next')) {
      const future = matched.filter(r => new Date(r.item.EnglishDate) >= now)
        .sort((a, b) => new Date(a.item.EnglishDate) - new Date(b.item.EnglishDate));
      setResults(future.slice(0, 10));
    } else if (q.includes('போன') || q.includes('கடந்த')) {
      const past = matched.filter(r => new Date(r.item.EnglishDate) < now)
        .sort((a, b) => new Date(b.item.EnglishDate) - new Date(a.item.EnglishDate));
      setResults(past.slice(0, 10));
    } else {
      const future = matched.filter(r => new Date(r.item.EnglishDate) >= now)
        .sort((a, b) => new Date(a.item.EnglishDate) - new Date(b.item.EnglishDate));
      const past = matched.filter(r => new Date(r.item.EnglishDate) < now)
        .sort((a, b) => new Date(b.item.EnglishDate) - new Date(a.item.EnglishDate));
      setResults([...future.slice(0, 8), ...past.slice(0, 4)]);
    }

    // Also search theetu data for relationship words
    const theetuMatched = [];
    const allTheetu = [...theetuData.death.map(t => ({ ...t, type: 'death' })), ...theetuData.birth.map(t => ({ ...t, type: 'birth' }))];
    for (const t of allTheetu) {
      const searchIn = [t.whome, t.theetu || t.details, t.extra, t.period].filter(Boolean).join(' ').toLowerCase();
      for (const term of searchTerms) {
        if (searchIn.includes(term)) { theetuMatched.push(t); break; }
      }
    }
    setTheetuResults(theetuMatched);

    if (matched.length === 0 && theetuMatched.length === 0) setNoResults(true);
    else saveRecent(searchQuery.trim(), matched[0]?.item);
    setIsLoading(false);
  }, [allData, theetuData, navigate, saveRecent]);

  // Voice search
  const startVoice = () => {
    const SR = window.webkitSpeechRecognition || window.SpeechRecognition;
    if (!SR) { alert('குரல் தேடல் இந்த உலாவியில் ஆதரிக்கப்படவில்லை'); return; }
    setVoiceActive(true);
    setVoiceText('🎙️ கேட்கிறது...');
    const rec = new SR();
    webRecRef.current = rec;
    rec.lang = 'ta-IN'; rec.continuous = false; rec.interimResults = true;
    rec.onresult = (e) => {
      let final = '', interim = '';
      for (let i = e.resultIndex; i < e.results.length; i++) {
        if (e.results[i].isFinal) final += e.results[i][0].transcript;
        else interim += e.results[i][0].transcript;
      }
      if (final.trim()) { setQuery(final.trim()); setVoiceText('✅ ' + final.trim()); }
      else if (interim.trim()) setVoiceText('🎙️ ' + interim.trim());
    };
    rec.onend = () => { setVoiceActive(false); setVoiceText(''); };
    rec.onerror = () => { setVoiceActive(false); setVoiceText('⚠️ குரல் கேட்கவில்லை'); setTimeout(() => setVoiceText(''), 2000); };
    rec.start();
  };

  const stopVoice = () => {
    if (webRecRef.current) webRecRef.current.stop();
    setVoiceActive(false); setVoiceText('');
  };

  const handleSubmit = (e) => { e?.preventDefault(); doSearch(query); };

  const chipStyle = (color) => ({
    display: 'inline-flex', alignItems: 'center', gap: '4px', padding: '5px 10px',
    borderRadius: '16px', fontSize: '0.7rem', fontWeight: 700, cursor: 'pointer',
    border: `1.5px solid ${color}`, color, background: 'transparent', margin: '3px',
    transition: 'all 0.15s',
  });

  const btnSm = { border: 'none', borderRadius: '6px', padding: '4px 10px', cursor: 'pointer', fontSize: '0.7rem', fontWeight: 700 };

  return (
    <div style={{ background: T.bg, minHeight: '80vh', padding: '10px' }}>
      {/* Header */}
      <div style={{ background: T.header, padding: '14px', borderRadius: '12px', textAlign: 'center', marginBottom: '10px', borderBottom: '3px solid #ff9800' }}>
        <h1 style={{ color: '#fff', margin: 0, fontSize: '1.1rem', fontWeight: 900 }}>🔍 தேடுக — கற்பக விருக்ஷம்</h1>
        <div style={{ color: T.gold, fontSize: '0.7rem', marginTop: '2px' }}>
          Search {allData.length.toLocaleString()} panchangam records • Voice + Text
        </div>
      </div>

      {/* Search Box */}
      <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '4px', marginBottom: '8px' }}>
        <input value={query} onChange={e => { setQuery(e.target.value); setShowSugg(true); setShowMore(false); }}
          placeholder="அடுத்த ஏகாதசி? / 14-05-2026 / தேடுக..."
          style={{ flex: 1, padding: '10px 12px', borderRadius: '10px', border: `2px solid ${T.greenDk}`, fontSize: '0.85rem', outline: 'none' }} />
        <button type="submit" disabled={isLoading} style={{ ...btnSm, background: T.greenDk, color: '#fff', padding: '8px 14px', borderRadius: '10px', fontSize: '0.9rem' }}>
          {isLoading ? '⏳' : '🔍'}
        </button>
        <button type="button" onClick={voiceActive ? stopVoice : startVoice}
          style={{ ...btnSm, background: voiceActive ? '#d32f2f' : '#fff', color: voiceActive ? '#fff' : '#333', padding: '8px 12px', borderRadius: '10px', fontSize: '0.9rem', border: '1px solid #ccc' }}>
          {voiceActive ? '⏹️' : '🎙️'}
        </button>
        {query && <button type="button" onClick={() => { setQuery(''); setResults([]); setNoResults(false); setShowSugg(true); }}
          style={{ ...btnSm, background: '#eee', color: '#333', padding: '8px', borderRadius: '10px' }}>✕</button>}
      </form>

      {/* Voice Status */}
      {voiceText && (
        <div style={{ background: '#fce4ec', padding: '8px 12px', borderRadius: '8px', fontSize: '0.8rem', color: '#c62828', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ animation: voiceActive ? 'pulse 1s infinite' : 'none' }}>🎙️</span> {voiceText}
        </div>
      )}

      {/* Suggestions / Recent Tabs */}
      {showSugg && results.length === 0 && !isLoading && (
        <div style={{ marginBottom: '10px' }}>
          <div style={{ display: 'flex', borderRadius: '8px', overflow: 'hidden', border: `1px solid ${T.greenDk}`, marginBottom: '8px' }}>
            <button onClick={() => setTab('suggestions')} style={{ flex: 1, padding: '7px', fontWeight: 700, fontSize: '0.75rem', border: 'none', cursor: 'pointer', background: tab === 'suggestions' ? T.greenDk : T.cream, color: tab === 'suggestions' ? '#fff' : T.greenDk }}>
              💡 இப்படி கேளுங்கள்
            </button>
            {recentSearches.length > 0 && (
              <button onClick={() => setTab('recent')} style={{ flex: 1, padding: '7px', fontWeight: 700, fontSize: '0.75rem', border: 'none', cursor: 'pointer', background: tab === 'recent' ? T.greenDk : T.cream, color: tab === 'recent' ? '#fff' : T.greenDk }}>
                🕐 சமீபத்தியவை ({recentSearches.length})
              </button>
            )}
          </div>

          {tab === 'suggestions' && (
            <div>
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {SUGGESTIONS.map((s, i) => (
                  <button key={i} onClick={() => { setQuery(s.q); doSearch(s.q); }} style={{...chipStyle(T.greenDk), flexDirection:'column', alignItems:'flex-start', textAlign:'left'}}>
                    <span>🔍 {s.q}</span>
                    <span style={{fontSize:'0.5rem',color:'#1565c0',fontWeight:400}}>{s.sub}</span>
                    <span style={{fontSize:'0.45rem',color:'#888',fontWeight:400}}>{s.sub2}</span>
                  </button>
                ))}
              </div>
              {!showMore && <button onClick={() => setShowMore(true)} style={{ ...btnSm, background: T.greenPale, color: T.greenDk, marginTop: '6px' }}>➕ மேலும் கேள்விகள்</button>}
              {showMore && (
                <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '6px' }}>
                  {MORE_SUGGESTIONS.map((s, i) => (
                    <button key={i} onClick={() => { setQuery(s.q); doSearch(s.q); }} style={{...chipStyle(T.orange), flexDirection:'column', alignItems:'flex-start', textAlign:'left'}}>
                      <span>→ {s.q}</span>
                      <span style={{fontSize:'0.5rem',color:'#1565c0',fontWeight:400}}>{s.sub}</span>
                      <span style={{fontSize:'0.45rem',color:'#888',fontWeight:400}}>{s.sub2}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}

          {tab === 'recent' && (
            <div>
              {recentSearches.map((r, i) => (
                <div key={i} onClick={() => { setQuery(r.query); doSearch(r.query); }}
                  style={{background:'#fff',borderRadius:'8px',padding:'8px 10px',marginBottom:'4px',border:'1px solid '+T.border,cursor:'pointer'}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                    <span style={{fontWeight:700,fontSize:'0.8rem',color:T.greenDk}}>🕐 {r.query}</span>
                    {r.date && <span style={{fontSize:'0.6rem',color:'#888'}}>{r.date}</span>}
                  </div>
                  {(r.thithi || r.nakshatra) && (
                    <div style={{fontSize:'0.6rem',color:T.maroon,marginTop:'2px'}}>
                      {r.thithi && <span>🌙 {r.thithi} </span>}
                      {r.nakshatra && <span>⭐ {r.nakshatra} </span>}
                      {r.tamilDate && <span style={{color:'#888'}}>({r.tamilDate})</span>}
                    </div>
                  )}
                  {r.special && <div style={{fontSize:'0.55rem',color:T.orange,marginTop:'1px'}}>✨ {r.special}</div>}
                </div>
              ))}
              <button onClick={() => { setRecent([]); localStorage.removeItem(RECENT_KEY); }}
                style={{ ...btnSm, background: '#ffebee', color: '#c62828', marginTop: '6px' }}>🗑️ அனைத்தையும் அழி</button>
            </div>
          )}
        </div>
      )}

      {/* Loading */}
      {isLoading && <div style={{ textAlign: 'center', padding: '30px', color: T.greenDk }}><div style={{ fontSize: '2rem' }}>⏳</div>தேடுகிறது...</div>}

      {/* Results */}
      {results.length > 0 && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
            <span style={{ fontSize: '0.8rem', fontWeight: 800, color: T.greenDk }}>📅 {results.length} தகவல்கள் கிடைத்தன</span>
            <button onClick={() => { setResults([]); setShowSugg(true); }} style={{ ...btnSm, background: T.greenPale, color: T.greenDk }}>← மீண்டும்</button>
          </div>
          {results.map((r, i) => {
            const d = r.item;
            const pk = d.PakshamNameInTamil?.includes('சுக்ல') ? 'சுக்.' : 'கிரு.';
            return (
              <div key={i} style={{ background: T.cream, borderRadius: '10px', padding: '10px 12px', marginBottom: '8px', border: `1px solid ${T.border}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ fontSize: '0.85rem', fontWeight: 800, color: T.greenDk }}>{d.EnglishDate} — {d.DayNameInTamil}</div>
                  <span style={{ fontSize: '0.6rem', fontWeight: 700, padding: '2px 8px', borderRadius: '8px', background: r.score >= 80 ? '#c8e6c9' : '#fff8e1', color: r.score >= 80 ? T.greenDk : T.orange }}>{r.score}%</span>
                </div>
                <div style={{ fontSize: '0.75rem', color: T.maroon, marginTop: '4px' }}>
                  {d.YearNameInTamil} | {d.TamilMonth} - {d.TamilDate}
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px', marginTop: '6px', fontSize: '0.7rem' }}>
                  <div><b>திதி:</b> {pk}{d.ThithiNameInTamil} - {Number(d.ThithiDuration || 0).toFixed(2)}</div>
                  <div><b>நட்சத்திரம்:</b> {d.NakshatraNameInTamil} - {Number(d.NakshatraDuration || 0).toFixed(2)}</div>
                  <div><b>யோகம்:</b> {d.YogaNameInTamil}</div>
                  <div><b>கரணம்:</b> {d.KaranamNameInTamil}</div>
                </div>
                {d.DaySpecialityInTamil && <div style={{ fontSize: '0.7rem', color: T.orange, fontWeight: 700, marginTop: '4px' }}>✨ {d.DaySpecialityInTamil}</div>}
                {/* Feedback */}
                <div style={{ display: 'flex', gap: '6px', marginTop: '6px', alignItems: 'center' }}>
                  <span style={{ fontSize: '0.6rem', color: '#888' }}>இது பயனுள்ளதா?</span>
                  {feedbackGiven[query + i] ? (
                    <span style={{ fontSize: '0.6rem', color: T.greenDk, fontWeight: 700 }}>✅ நன்றி!</span>
                  ) : (<>
                    <button onClick={() => saveFeedback(query + i, true)} style={{ ...btnSm, background: '#e8f5e9', color: T.greenDk, fontSize: '0.6rem' }}>👍 ஆம்</button>
                    <button onClick={() => saveFeedback(query + i, false)} style={{ ...btnSm, background: '#ffebee', color: '#c62828', fontSize: '0.6rem' }}>👎 இல்லை</button>
                  </>)}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Theetu Results */}
      {theetuResults.length > 0 && (
        <div style={{ marginTop: results.length > 0 ? '10px' : 0 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
            <span style={{ fontSize: '0.8rem', fontWeight: 800, color: T.maroon }}>🕯️ தீட்டு விதிகளில் {theetuResults.length} தகவல்கள்</span>
            {results.length === 0 && <button onClick={() => { setTheetuResults([]); setShowSugg(true); }} style={{ ...btnSm, background: T.greenPale, color: T.greenDk }}>← மீண்டும்</button>}
          </div>
          {theetuResults.map((t, i) => (
            <div key={i} style={{ background: t.type === 'death' ? '#fff8e1' : '#e8f5e9', padding: '8px 10px', borderRadius: '6px', marginBottom: '4px', border: '1px solid ' + (t.type === 'death' ? '#ffe082' : T.border) }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontWeight: 700, fontSize: '0.75rem', color: t.type === 'death' ? '#c62828' : T.greenDk }}>{t.type === 'death' ? '🥀' : '👶'} {t.whome}</span>
                <span style={{ fontSize: '0.65rem', fontWeight: 700, color: T.orange }}>{t.period}</span>
              </div>
              <div style={{ fontSize: '0.7rem', color: T.maroon, marginTop: '2px' }}>{t.theetu || t.details}</div>
              {t.extra && <div style={{ fontSize: '0.6rem', color: T.orange, marginTop: '2px' }}>{t.extra}</div>}
            </div>
          ))}
          <div style={{ display: 'flex', gap: '6px', marginTop: '8px' }}>
            <Link to="/marana-theetu" style={{ flex: 1, textDecoration: 'none', background: '#ffebee', padding: '8px', borderRadius: '6px', textAlign: 'center', fontWeight: 700, fontSize: '0.7rem', color: '#c62828' }}>🥀 முழு மரண தீட்டு</Link>
            <Link to="/gentheetu" style={{ flex: 1, textDecoration: 'none', background: '#e8f5e9', padding: '8px', borderRadius: '6px', textAlign: 'center', fontWeight: 700, fontSize: '0.7rem', color: T.greenDk }}>👶 முழு ஜனன தீட்டு</Link>
          </div>
        </div>
      )}

      {/* No Results */}
      {noResults && (
        <div style={{ background: T.saffron, padding: '16px', borderRadius: '10px', textAlign: 'center' }}>
          <div style={{ fontSize: '1.5rem' }}>😕</div>
          <div style={{ fontSize: '0.85rem', fontWeight: 700, color: T.maroon }}>"{query}" — தகவல் கிடைக்கவில்லை</div>
          <div style={{ fontSize: '0.7rem', color: '#888', marginTop: '4px' }}>Try: 17-07-2026, ஏகாதசி, அமாவாசை, பிரதோஷம்</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '8px' }}>
            {SUGGESTIONS.slice(0, 6).map((s, i) => (
              <button key={i} onClick={() => { setQuery(s.q); doSearch(s.q); }} style={chipStyle(T.orange)}>🔍 {s.q}</button>
            ))}
          </div>
        </div>
      )}

      {/* Browse All - when idle */}
      {results.length === 0 && !isLoading && !noResults && (
        <div style={{ marginTop: '10px' }}>
          <div style={{ fontSize: '0.8rem', fontWeight: 800, color: T.greenDk, marginBottom: '8px' }}>📚 அனைத்து பக்கங்கள்</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '4px' }}>
            {Object.entries(NAV_MAP).map(([name, route], i) => (
              <Link key={i} to={route} style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px',
                padding: '8px 4px', textDecoration: 'none', borderRadius: '8px',
                fontSize: '0.6rem', fontWeight: 700, color: T.greenDk, textAlign: 'center',
              }}>{name}</Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchPage;